module.exports = {
  xxlargeBoldFontWeight: "bold",
  largeBoldFontWeight: "bold",
  xlargeBoldFontSize: "32px",
  fontFamilyJa: "'BrandonText', 'Helvetica Neue', Helvetica, Arial, OpenTableHiragino, Roboto, Droid Sans, '游ゴシック体', OpenTableYuGothic, YuGothic, Yu Gothic, 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif",
  xlargeBoldLineHeight: "36px",
  fontFamily: "'BrandonText', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  xxsmallMediumFontWeight: "medium",
  smallMediumFontWeight: "500",
  xsmallMediumFontSize: "14px",
  xsmallMediumLineHeight: "20px",
  mediumBoldFontWeight: "bold",
  xxxsmallRegularFontWeight: "normal",
  xsmallRegularFontWeight: "normal",
  smallRegularFontSize: "16px",
  xxsmallRegularFontSize: "12px",
  xxlargeBoldFontSize: "48px",
  largeBoldFontSize: "24px",
  smallRegularLineHeight: "24px",
  xxsmallRegularLineHeight: "16px",
  xxlargeBoldLineHeight: "56px",
  largeBoldLineHeight: "28px",
  xsmallBoldFontWeight: "bold",
  fontWeightMedium: "500",
  xxsmallMediumFontSize: "12px",
  smallMediumFontSize: "16px",
  xxsmallMediumLineHeight: "16px",
  smallMediumLineHeight: "24px",
  mediumBoldFontSize: "18px",
  mediumBoldLineHeight: "24px",
  xxxsmallRegularFontSize: "10px",
  xsmallRegularFontSize: "14px",
  largeMediumFontWeight: "500",
  xxxsmallRegularLineHeight: "12px",
  xsmallRegularLineHeight: "20px",
  smallBoldFontWeight: "bold",
  xsmallBoldFontSize: "14px",
  xsmallBoldLineHeight: "20px",
  xlargeBoldFontWeight: "bold",
  largeMediumFontSize: "24px",
  largeMediumLineHeight: "32px",
  fontWeightBold: "bold",
  fontFamilyBrand: "BrandonText",
  xsmallMediumFontWeight: "500",
  smallBoldFontSize: "16px",
  fontWeightNormal: "normal",
  smallBoldLineHeight: "24px",
  xxsmallRegularFontWeight: "normal",
  smallRegularFontWeight: "normal",
};